import { resolveApiBaseUrl } from '../utils/apiBase';

const API = () => resolveApiBaseUrl();

export async function listStringersArticles(page = 0, size = 20) {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
    sortBy: 'publishedAt',
    sortDir: 'desc',
  });
  const response = await fetch(`${API()}/stringers?${params}`, {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `Request failed (${response.status})`);
  }
  return response.json();
}
